import gql from 'graphql-tag'

export default gql`
query listLoadProducts($filter: ProductFilterArgs $params: ListQueryArgs) {
	cashAssist {
		listProducts(filter: $filter, params: $params) {
			items {
				name
				id
			}
			cursors {
				hasNext
				hasPrevious
				before
				after
			}
		}
	}
}
`
